import { createContext, useState, useEffect, useContext } from "react";
import EventService from "services/event.service";
import { AuthContext } from "context";

export const ScheduleContext = createContext();

export const ScheduleProvider = ({ children }) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  // Agenda é Premium: para free a API responde 403 premium_required (abriria o modal no login)
  const isPremium = Boolean(user?.is_premium);
  const [schedule, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);


  const loadEvents = async (date = new Date()) => {
  setLoading(true);
  try {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const response = await EventService.getEvents(month, year);

    setEvents(Array.isArray(response) ? response : []);
  } catch (error) {
    console.error("Erro ao carregar agenda:", error);
    setEvents([]);
  } finally {
    setLoading(false);
  }
};

  const updateEvent = async (id, data) => {
    const response = await EventService.update(id, data);

    setSchedule((prev) =>
      prev.map((e) => (e.id === id ? response.data : e))
    );

    return response.data;
  };


  useEffect(() => {
    if (isAuthenticated && isPremium) {
      loadEvents(selectedDate);
    }
  }, [selectedDate, isAuthenticated, isPremium]);

  return (
    <ScheduleContext.Provider
      value={{
        schedule,
        setEvents,
        selectedDate,
        setSelectedDate,
        loadEvents,
        loading,
      }}
    >
      {children}
    </ScheduleContext.Provider>
  );
};
